var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.87565 17.7903V13.207H11.1256V14.8737H17.7923V16.1237H11.1256V17.7903H9.87565ZM3.20898 16.1237V14.8737H7.79228V16.1237H3.20898ZM6.54232 12.7903V11.1237H3.20898V9.8737H6.54232V8.20703H7.79228V12.7903H6.54232ZM9.87565 11.1237V9.8737H17.7923V11.1237H9.87565ZM13.209 7.79032V3.20703H14.4589V4.8737H17.7923V6.12366H14.4589V7.79032H13.209ZM3.20898 6.12366V4.8737H11.1256V6.12366H3.20898Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilter);
export default __webpack_public_path__ + "static/media/icon_filter.5d0a98af2fa0d3cfaff667815a740b9e.svg";
export { ForwardRef as ReactComponent };